<template>
  <v-card
    class="mb-4 summary-card d-flex"
    color="white"
    style="min-height: 100%"
  >
    <v-card-title class="text-overline" v-if="quotes.length > 0"
      >Cotizaciones</v-card-title
    >
    <v-card-text v-if="quotes.length > 0">
      <v-card class="mb-2" v-for="quote in quotes" :key="quote.id" outlined>
        <v-card-title class="d-flex justify-space-between align-center">
          <div class="text-subtitle-1 font-weight-bold">
            {{ quote.name }}
          </div>
          <!-- <v-chip color="green lighten-4" text-color="green darken-3" small>
                {{ quote.status }}
              </v-chip> -->
          <v-chip
            :color="getChipColor(quote.status)"
            :text-color="getTextColor(quote.status)"
            small
            class="font-weight-bold"
          >
            <v-icon left small>{{ getChipIcon(quote.status) }}</v-icon>
            {{ getText(quote.status) }}
          </v-chip>
        </v-card-title>

        <v-card-text class="py-0">
          <div class="d-flex justify-space-between">
            <div class="text-subtitle-2 font-weight-bold" v-if="quote.project">
              Para el proyecto: {{ quote.project.name ?? "" }}
            </div>
            <v-btn
              small
              rounded
              dark
              @click="showDetail(quote.id)"
              elevation="0"
            >
              Ver detalle
            </v-btn>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <!-- <v-btn icon>
                <v-icon>mdi-download</v-icon>
              </v-btn> -->
        </v-card-actions>
      </v-card>
      <!-- <v-btn 
            medium
            block
            style="background-color: #000; color: #fff;"
            elevation="0"
            v-if="quotes.length > 0"
          >
            Ver todas
          </v-btn>
           -->
    </v-card-text>
    <v-card-text
      v-else
      class="d-flex align-center justify-center flex-column"
      style="height: 100%"
    >
      <div v-if="!hasProjects && !hasQuotes" class="text-center">
        <div
          class="text-h4 mb-5"
          style="color: #000; font-weight: 300 !important"
        >
          🚧 No has comenzado tu primera obra
        </div>
        <p style="font-size: 1.2em" class="mb-5">
          Para cotizar materiales, primero necesitás crear un proyecto. Así
          podrás llevar el control de tu obra y recibir cotizaciones de
          múltiples proveedores.
        </p>
        <v-btn
          @click="showProjectForm"
          :elevation="0"
          style="
            min-height: 50px;
            padding: 25px;
            width: 50%;
            font-size: 1.2em;
            border-radius: 8px;
            cursor: pointer;
            color: #ffffff;
            border: 1px solid #000;
            background-color: #000000;
          "
        >
          + Crear proyecto
        </v-btn>
      </div>
      <div v-if="hasProjects && !hasQuotes" class="text-center">
        <div class="text-h5" style="color: #000">
          📦 Aún no tienes cotizaciones cargadas.
        </div>
        <p style="color: #000000dc" class="mt-4 mb-5">
          Solicitá precios a varios proveedores con un solo mensaje. <br />
          Agregá los materiales que necesitás y empezá a recibir respuestas hoy
          mismo.
        </p>
        <v-btn
          @click="showQuoteForm"
          :elevation="0"
          style="
            min-height: 50px;
            width: 100%;
            font-size: 1.2em;
            border-radius: 8px;
            cursor: pointer;
            color: #ffffff;
            border: 1px solid #000;
            background-color: #000000;
          "
        >
          Cotizar materiales ahora
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: ["hasProjects", "quotes"],

  data() {
    return {};
  },

  methods: {
    showProjectForm() {
      this.$emit("showProjectForm");
    },
    showQuoteForm() {
      this.$emit("showQuoteForm");
    },

    getText(status) {
      switch (status.toLowerCase()) {
        case "pending":
          return "Pendiente";
        case "completed":
          return "Cotizada";
        case "no_response":
          return "Sin respuesta";
        default:
          return "Sin respuesta";
      }
    },

    getChipColor(status) {
      switch (status.toLowerCase()) {
        case "pending":
          return "orange lighten-4";
        case "completed":
          return "green lighten-4";
        case "no_response":
          return "grey lighten-3";
        default:
          return "grey lighten-1";
      }
    },
    getTextColor(status) {
      switch (status.toLowerCase()) {
        case "pending":
          return "orange darken-2";
        case "completed":
          return "green darken-2";
        case "no_response":
          return "grey darken-2";
        default:
          return "grey darken-3";
      }
    },
    getChipIcon(status) {
      switch (status.toLowerCase()) {
        case "pending":
          return "mdi-clock";
        case "completed":
          return "mdi-check-circle";
        case "no_response":
          return "mdi-help-circle";
        default:
          return "mdi-help-circle";
      }
    },

    async showDetail(id) {
      if (
        this.$route.params.id !== String(id) ||
        this.$route.name !== "quotes-detail"
      ) {
        this.$router.push({ name: "quotes-detail", params: { id } });
      }
    },
  },

  computed: {
    hasQuotes() {
      return this.quotes.length > 0;
    },
  },
};
</script>
